import { useState, type ReactNode } from "react";
import {
  TablePreferencesButton,
  TablePreferencesModal,
} from "./TablePreferencesModal";
import type { DataTableLabels } from "./tableLabels";
import type { TablePreferences } from "./tablePreferencesStorage";
import type { TableColumnPreferenceMeta } from "./useTablePreferences";

interface TablePreferencesSlotProps {
  labels: DataTableLabels;
  closeLabel: string;
  columns: TableColumnPreferenceMeta[];
  preferences: TablePreferences;
  onApply: (next: TablePreferences) => void;
  onReset: () => void;
  showPageSize?: boolean;
}

/** Shared gear + modal wiring used by DataTable. */
export function TablePreferencesSlot({
  labels,
  closeLabel,
  columns,
  preferences,
  onApply,
  onReset,
  showPageSize = true,
}: TablePreferencesSlotProps): ReactNode {
  const [open, setOpen] = useState(false);
  return (
    <>
      <TablePreferencesButton labels={labels} onClick={() => setOpen(true)} />
      {open ? (
        <TablePreferencesModal
          isOpen
          onClose={() => setOpen(false)}
          labels={labels}
          closeLabel={closeLabel}
          columns={columns}
          value={preferences}
          onApply={onApply}
          onReset={onReset}
          showPageSize={showPageSize}
        />
      ) : null}
    </>
  );
}

export function orderColumnsByIds<T extends { id: string }>(
  columns: T[],
  orderedIds: string[],
): T[] {
  const byId = new Map(columns.map((column) => [column.id, column] as const));
  return orderedIds
    .map((id) => byId.get(id))
    .filter((column): column is T => column != null);
}
